import React from "react";

const DYNICTY_LOGO = "/brand/dynicty-logo-official.webp";

/* Exact asset mapping (do not infer): welcome → Login, register → Register,
   reset → Forgot/Reset Password. PNG = supplied source; WEBP = compressed
   derivative for mobile bandwidth, PNG stays the fallback. */
export const MOBILE_MASCOTS = {
  welcome: { png: "/brand/auth/welcome.png", webp: "/brand/auth/welcome.webp", greeting: "Hi! I'm Dyni", glow: "rgba(0,210,255,0.45)", accent: "#67e8f9" },
  register: { png: "/brand/auth/register.png", webp: "/brand/auth/register.webp", greeting: "Let's Grow Together!", glow: "rgba(168,85,247,0.45)", accent: "#d8b4fe" },
  reset: { png: "/brand/auth/reset.png", webp: "/brand/auth/reset.webp", greeting: "No Worries, We've Got You!", glow: "rgba(59,130,246,0.45)", accent: "#93c5fd" },
};

export function MobileDyniHeader({ variant = "welcome", greeting, subline = "Always here to help you grow!" }) {
  const m = MOBILE_MASCOTS[variant] || MOBILE_MASCOTS.welcome;
  return (
    <div className="lg:hidden w-full max-w-md mx-auto mb-4 dyn-rise" data-testid="mobile-dyni-header" data-variant={variant}>
      <img src={DYNICTY_LOGO} alt="Dynicty" className="h-10 w-auto object-contain mx-auto mb-2" data-testid="mobile-dynicty-logo" />
      <div className="dyn-mobile-hero">
        <div className="dyn-mobile-mascot dyn-float-slow" style={{ "--dyn-mascot-glow": m.glow }}>
          <picture>
            <source srcSet={m.webp} type="image/webp" />
            <img src={m.png} alt="Dyni, maskot Dynicty" data-testid="mobile-dyni-mascot" data-variant={variant} />
          </picture>
        </div>
        <div className="dyn-glass-card dyn-mobile-bubble" style={{ borderColor: m.glow }} data-testid="mobile-dyni-greeting">
          <p className="text-sm font-extrabold leading-tight" style={{ color: m.accent }}>{greeting || m.greeting}</p>
          <p className="text-[11px] leading-tight mt-0.5" style={{ color: "#cbd5e1" }}>{subline}</p>
        </div>
      </div>
    </div>
  );
}
